export default "__VITE_ASSET__G0RCvehO__"